<script lang="ts">
  import { Input } from '$components/BlockInput';
  import Search from '$components/Icons/Search.svelte';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';

  interface Props {
    placeholder?: string;
    disableSubmit?: boolean;
    clearOnSubmit?: boolean;
    onSubmit?: (query: string) => void;
    onInput?: (query: string) => void;
  }

  let {
    placeholder = 'Search...',
    disableSubmit = false,
    clearOnSubmit = true,
    onSubmit,
    onInput
  }: Props = $props();

  let value = $state('');

  const handleSubmit = (event: Event) => {
    event.preventDefault();
    const query = value;
    if (!query || disableSubmit) return;
    onSubmit?.(query);
    if (clearOnSubmit) {
      value = '';
    }
  };

  const handleInput = (event: Event) => {
    value = (event.target as HTMLInputElement).value;
    onInput?.(value);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(event);
    }
  };
</script>

<form class="search-form" onsubmit={handleSubmit}>
  <FontSizeDecorator size="normal">
    <Input
      type="search"
      id="search-input"
      bind:value
      oninput={handleInput}
      onkeydown={handleKeyDown}
      {placeholder}
      showClear={true}
    >
      {#snippet icon()}
        <Search />
      {/snippet}
    </Input>
  </FontSizeDecorator>
</form>

<style lang="scss">
  .search-form {
    width: 100%;
    margin: 0 auto;
  }
</style>
